// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Lock, User, ArrowLeft } from 'lucide-react';
// import { toast } from 'sonner';
// import axios from 'axios';

// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // Change line 7
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
// const API = `${BACKEND_URL}/api`;

// const AdminLogin = () => {
//   const navigate = useNavigate();
//   const [credentials, setCredentials] = useState({
//     username: '',
//     password: ''
//   });
//   const [loading, setLoading] = useState(false);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await axios.post(`${API}/admin/login`, credentials);
      
//       if (response.data.token) {
//         // Store token in localStorage
//         localStorage.setItem('admin_token', response.data.token);
//         toast.success('Login berhasil!');
//         navigate('/admin');
//       }
//     } catch (error) {
//       console.error('Login error:', error);
//       toast.error('Username atau password salah');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-primary/10 flex items-center justify-center px-4">
//       <div className="w-full max-w-md">
//         {/* Back Button */}
//         <button
//           onClick={() => navigate('/')}
//           className="mb-6 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
//         >
//           <ArrowLeft className="w-4 h-4" />
//           <span>Kembali ke Beranda</span>
//         </button>

//         {/* Login Card */}
//         <div className="bg-surface rounded-2xl border border-border shadow-xl p-8">
//           {/* Header */}
//           <div className="text-center mb-8">
//             <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
//               <Lock className="w-8 h-8 text-white" />
//             </div>
//             <h1 className="text-2xl font-bold text-foreground mb-2">Admin Panel</h1>
//             <p className="text-sm text-muted-foreground">Masuk untuk kelola UMKM Pilihan</p>
//           </div>

//           {/* Login Form */}
//           <form onSubmit={handleLogin} className="space-y-6">
//             {/* Username Input */}
//             <div>
//               <label className="block text-sm font-medium text-foreground mb-2">
//                 Username
//               </label>
//               <div className="relative">
//                 <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
//                 <input
//                   type="text"
//                   value={credentials.username}
//                   onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
//                   placeholder="Masukkan username"
//                   className="w-full pl-11 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
//                   required
//                 />
//               </div>
//             </div>

//             {/* Password Input */}
//             <div>
//               <label className="block text-sm font-medium text-foreground mb-2">
//                 Password
//               </label>
//               <div className="relative">
//                 <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
//                 <input
//                   type="password"
//                   value={credentials.password}
//                   onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
//                   placeholder="Masukkan password"
//                   className="w-full pl-11 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
//                   required
//                 />
//               </div>
//             </div>

//             {/* Login Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full py-3 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {loading ? 'Memproses...' : 'Masuk'}
//             </button>
//           </form>

//           {/* Info */}
//           <div className="mt-6 p-4 bg-muted/30 rounded-lg">
//             <p className="text-xs text-muted-foreground text-center">
//               🔒 Halaman ini hanya untuk admin CariWarung
//             </p>
//           </div>
//         </div>

//         {/* Demo Credentials Note */}
//         <div className="mt-6 p-4 bg-surface/50 rounded-lg border border-border/50">
//           <p className="text-xs text-muted-foreground text-center mb-2">
//             <strong>Demo Credentials:</strong>
//           </p>
//           <p className="text-xs text-muted-foreground text-center font-mono">
//             Username: <strong>admin</strong> | Password: <strong>admin123</strong>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminLogin;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      
      if (response.data.token) {
        // Store token in localStorage
        localStorage.setItem('admin_token', response.data.token);
        toast.success('Login berhasil!');
        navigate('/admin');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Username atau password salah');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-primary/10 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          className="mb-6 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Kembali ke Beranda</span>
        </button>

        {/* Login Card */}
        <div className="bg-surface rounded-2xl border border-border shadow-xl p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-foreground mb-2">Admin Panel</h1>
            <p className="text-sm text-muted-foreground">Masuk untuk kelola UMKM Pilihan</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleLogin} className="space-y-6">
            {/* Username Input */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Username
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                <input
                  type="text"
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  placeholder="Masukkan username"
                  className="w-full pl-11 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
                  required
                />
              </div>
            </div>

            {/* Password Input */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Password
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                <input
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  placeholder="Masukkan password"
                  className="w-full pl-11 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
                  required
                />
              </div>
            </div>

            {/* Login Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Memproses...' : 'Masuk'}
            </button>
          </form>

          {/* Info */}
          <div className="mt-6 p-4 bg-muted/30 rounded-lg">
            <p className="text-xs text-muted-foreground text-center">
              🔒 Halaman ini hanya untuk admin Bangkalan UMKM
            </p>
          </div>
        </div>

        {/* Demo Credentials Note */}
        <div className="mt-6 p-4 bg-surface/50 rounded-lg border border-border/50">
          <p className="text-xs text-muted-foreground text-center mb-2">
            <strong>Demo Credentials:</strong>
          </p>
          <p className="text-xs text-muted-foreground text-center font-mono">
            Username: <strong>admin</strong> | Password: <strong>admin123</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
